<template>
  <div class=" content-page ">
    <div class="page-title flex-center-start">
      <img :src="backUrl" alt="" @click="back">
      {{ $t('pageTitle.help') }} </div>


    <div class="content" v-html="content"></div>

  </div>
</template>
<script>
export default {
  components: {
  },
  data() {
    return {
      backUrl: require('../../assets/imgs/icon-back.png'),
      content: ''
    }
  },
  computed: {
    appName() {
      return this.$store.state.appName
    }
  },
  methods: {
    back() {
      this.$router.go(-1)
    },
    toPath(path) {
      if (path) {
        this.$router.push({
          name: path
        })
      }
    },
    toRefresh() {
      this.$toast.success(this.i18n.t('about.label3'))
    }
  }
}
</script>